import theme from "@elegantstack/flow-ui-theme/src/theme/index";
import colors from "@elegantstack/flow-ui-theme/src/theme/color-preset";
import beta from "@elegantstack/flow-ui-theme/src/theme/colors";
import omega from "@elegantstack/flow-ui-theme/src/theme/colors";

const CustomTheme = () => {
    return {
        ...theme,
        colors: {
            ...theme.colors,
            alphaLighter: '#afc6c9',
            alphaLight: '#8eafb3',
            alpha: '#5e8d93', //primula color
            alphaDark: '#4b7176',
            alphaDarker: '#385558',
            successLight: colors.green[100],
            success: colors.green[500],
            errorLight: colors.orange[200],
            error: colors.orange[500],
            modes: {
                dark: {
                    // Reverse alpha
                    alphaLighter: '#385558',
                    alphaLight: '#4b7176',
                    alphaDark: '#8eafb3',
                    alphaDarker: '#afc6c9',

                    // Reverse beta
                    betaLighter: beta.betaDarker,
                    betaLight: beta.betaDark,
                    betaDark: beta.betaLight,
                    betaDarker: beta.betaLighter,

                    // Reverse omega
                    omegaLighter: omega.omegaDarker,
                    omegaLight: omega.omegaDark,
                    omegaDark: omega.omegaLight,
                    omegaDarker: omega.omegaLighter,

                    text: colors.gray[400],
                    article: colors.gray[300],
                    heading: colors.gray[200],

                    background: colors.gray[900],
                    contentBg: colors.gray[800],
                    headerBg: colors.gray[800],
                    footerBg: colors.gray[800],

                    mute: colors.gray[600]
                }
            }
        }
    }
}

export default CustomTheme;